import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "resultCount", "option", "optionCount", "group", "submit"]

  connect() {
    this.abortController = null
    this.debounceTimer = null
  }

  disconnect() {
    this.abortController?.abort()
    clearTimeout(this.debounceTimer)
  }

  refresh() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.fetchFacets(), 140)
  }

  async fetchFacets() {
    this.abortController?.abort()
    this.abortController = new AbortController()
    this.submitTarget.setAttribute("aria-busy", "true")

    const url = new URL(this.formTarget.action, window.location.origin)
    url.hash = ""
    url.search = new URLSearchParams(new FormData(this.formTarget)).toString()
    url.searchParams.set("format", "json")

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal,
      })
      if (!response.ok) throw new Error(`Facet request failed: ${response.status}`)

      this.update(await response.json())
    } catch (error) {
      if (error.name !== "AbortError") console.warn(error)
    } finally {
      this.submitTarget.removeAttribute("aria-busy")
    }
  }

  update({ result_count: resultCount, tags, categories }) {
    this.resultCountTargets.forEach((target) => { target.textContent = resultCount })

    const counts = new Map([
      ...tags.map(({ slug, count }) => [`tag:${slug}`, count]),
      ...categories.map(({ slug, count }) => [`category:${slug}`, count]),
    ])

    this.optionTargets.forEach((option) => {
      const input = option.querySelector("input")
      const count = counts.get(`${option.dataset.filterPreviewKind}:${option.dataset.filterPreviewSlug}`) || 0
      option.querySelector("[data-filter-preview-target='optionCount']").textContent = count
      option.hidden = count === 0 && !input.checked
    })

    this.groupTargets.forEach((group) => {
      group.hidden = ![...group.querySelectorAll("[data-filter-preview-target='option']")].some((option) => !option.hidden)
    })
  }
}
